import { render, staticRenderFns } from "./PayersImportList.vue?vue&type=template&id=1db27ccb&scoped=true"
import script from "./PayersImportList.vue?vue&type=script&lang=js"
export * from "./PayersImportList.vue?vue&type=script&lang=js"
import style0 from "./PayersImportList.vue?vue&type=style&index=0&id=1db27ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db27ccb",
  null
  
)

export default component.exports